import React from 'react';

/**
 * A quiet line next to a date picker saying whether the cached day on screen is being re-checked, or
 * could not be re-checked. Cached data renders immediately and revalidates in the background
 * (data/queries.ts); this is how the user knows which of those states they are looking at.
 */
const DataFreshnessNote: React.FC<{ refreshing: boolean; refreshFailed?: boolean; onRetry?: () => void }> = ({
  refreshing, refreshFailed = false, onRetry,
}) => {
  if (refreshing) {
    return <span role="status" style={{ fontSize: '0.75em', color: 'var(--text-faint)' }}>Refreshing…</span>;
  }
  if (refreshFailed) {
    return (
      <span role="status" style={{ fontSize: '0.75em', color: 'var(--warning-text, var(--amber))', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
        Couldn’t refresh — showing the last loaded data.
        {onRetry && (
          <button type="button" className="btn btn-secondary btn-small" style={{ padding: '1px 8px', fontSize: '1em' }} onClick={onRetry}>
            Retry
          </button>
        )}
      </span>
    );
  }
  return null;
};

export default DataFreshnessNote;
